module.exports = __webpack_public_path__ + "img/BoldTeam.c517015e.png";